module.exports = __webpack_public_path__ + "static/media/noSmile.d1726626.svg";